export default __webpack_public_path__ + "static/date-label-anatomy-light-a8d975cec48c9a82e391243825f717d49838be1c9de10ec0847bd1a53edb116f.png";